<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="vehicleTable"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 8, xl: 8, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true">
        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.sector', 1)} ${$tc('message.activity', 1).toLowerCase()}`"
                                label-for="input-activity-sector">
                    <model-list-select id="input-activity-sector"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="activitySectorOptions && activitySectorOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="activitySectorFilter"
                                       :list="activitySectorOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.society', 1)"
                                label-for="input-corp">
                    <model-list-select id="input-corp"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="companyFilter"
                                       :list="companyOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.property', 1)}`"
                                label-for="input-owner">
                    <model-list-select id="input-owner"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="ownerOptions && ownerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="ownerFilter"
                                       :list="ownerOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$t('message.vehicleUsage')"
                                label-for="input-removegd">
                    <model-list-select id="input-removegd"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="ownershipTypeOptions && ownershipTypeOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="ownershipTypeFilter"
                                       :list="ownershipTypeOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.status', 1)} ${$tc('message.vehicle', 1).toLowerCase()}`"
                                label-for="input-state-vehicle">
                    <model-list-select id="input-state-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="vehicleStateOptions && vehicleStateOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="vehicleStateFilter"
                                       :list="vehicleStateOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="2" xl="2">
                  <b-form-group :label="$t('message.inOperation')"
                                label-for="input-removed">
                    <model-list-select id="input-removed"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="removedOptions && removedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="removedFilter"
                                       :list="removedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="2" xl="2">
                  <b-form-group :label="`${$t('message.hasOBU')}`"
                                label-for="input-obu">
                    <model-list-select id="input-obu"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="hasTrackerOptions && hasTrackerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="hasTrackerFilter"
                                       :list="hasTrackerOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$t('message.maxWeight')}`"
                                label-for="input-maxWeight">
                    <model-list-select id="input-maxWeight"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="maxWeightOption && maxWeightOption.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="maxWeightFilter"
                                       :list="maxWeightOption">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="2" xl="4">
                  <b-form-group label="Kg"
                                label-for="input-kg">
                    <b-form-input id="input-kg"
                                  v-model="kg"
                                  autocomplete="off" type="number"
                                  :placeholder="`${$tc('message.example', 1)}: 7500`">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="handleExcel($tc('message.vehicle', 2), getExcelFields())">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { cloneDeep, filter, find, orderBy, last } from 'lodash'

export default {
  name: 'ReportVehicles',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.fetchData()
      }
    })
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    const config = this.$route.meta.config

    return {
      config,
      DateTime,
      isMobile: false,
      trackers: [],
      fields: [],
      originalItems: [],
      items: [],
      itemsList: [],
      // filters
      activitySectorOptions: [],
      activitySectorFilter: '',
      companyOptions: [],
      companyFilter: '',
      ownerOptions: [],
      ownerFilter: '',
      vehicleStateOptions: [],
      vehicleStateFilter: '',
      ownershipTypeOptions: [],
      ownershipTypeFilter: '',
      wasteOptions: [],
      removedOptions: [],
      removedFilter: '',
      hasTrackerOptions: [],
      hasTrackerFilter: '',
      maxWeightOption: [],
      maxWeightFilter: true,
      kg: 0,
      // other options for excel
      fuelsOptions: [],
      classificationOptions: [],
      equipmentOptions: [],
      showCollapse: false,
      useCase: []
    }
  },
  watch: {
    activitySectorFilter (val) {
      this.items = this.getItems(val, 'activitySectorFilter')
    },
    companyFilter (val) {
      this.items = this.getItems(val, 'companyFilter')
    },
    ownerFilter (val) {
      this.items = this.getItems(val, 'ownerFilter')
    },
    vehicleStateFilter (val) {
      this.items = this.getItems(val, 'vehicleStateFilter')
    },
    ownershipTypeFilter (val) {
      this.items = this.getItems(val, 'ownershipTypeFilter')
    },
    removedFilter (val) {
      this.items = this.getItems(val, 'removedFilter')
    },
    hasTrackerFilter (val) {
      this.items = this.getItems(val, 'hasTrackerFilter')
    },
    maxWeightFilter (val) {
      this.items = this.getItems(val, 'maxWeightFilter')
    },
    kg (val) {
      this.items = this.getItems(val, 'kg')
    }
  },
  methods: {
    pushToEdit (item) {
      item && item.id ? this.$router.push({
        name: 'EditVehicle', params: { id: item.id }
      }) : this.$router.push({
        name: 'EditVehicle', params: { id: 'new' }
      })
    },
    getItems (value, field) {
      const activitySector = field === 'activitySectorFilter' ? value : this.activitySectorFilter
      const company = field === 'companyFilter' ? value : this.companyFilter
      const owner = field === 'ownerFilter' ? value : this.ownerFilter
      const vehicleState = field === 'vehicleStateFilter' ? value : this.vehicleStateFilter
      const ownershipType = field === 'ownershipTypeFilter' ? value : this.ownershipTypeFilter
      const removed = field === 'removedFilter' ? value : this.removedFilter
      const hasTracker = field === 'hasTrackerFilter' ? value : this.hasTrackerFilter
      const maxWeight = field === 'maxWeightFilter' ? value : this.maxWeightFilter
      const kg = field === 'kg' ? value : this.kg
      let editedItems = cloneDeep(this.originalItems)

      if (activitySector && activitySector !== '') {
        editedItems = filter(editedItems, obj => obj.activitySectorValue === find(this.activitySectorOptions, obj => obj.value === activitySector).value)
      }
      if (company && company !== '') {
        editedItems = filter(editedItems, obj => obj.userCompanyValue === find(this.companyOptions, obj => obj.value === company).value)
      }
      if (owner && owner !== '') {
        editedItems = filter(editedItems, obj => obj.propertyValue === find(this.ownerOptions, obj => obj.value === owner).value)
      }
      if (vehicleState && vehicleState !== '') {
        editedItems = filter(editedItems, obj => obj.stateValue === find(this.vehicleStateOptions, obj => obj.value === vehicleState).value)
      }
      if (ownershipType && ownershipType !== '') {
        editedItems = filter(editedItems, obj => obj.ownershipValue === find(this.ownershipTypeOptions, obj => obj.value === ownershipType).value)
      }
      if (removed !== '') {
        editedItems = filter(editedItems, obj => obj.disabledValue === removed)
      }
      if (hasTracker !== '') {
        editedItems = filter(editedItems, obj => hasTracker ? obj.trackerSerialNumber : !obj.trackerSerialNumber)
      }
      if (maxWeight === true && kg !== 0) {
        editedItems = filter(editedItems, obj => obj.traction ? parseInt(obj.traction) >= kg && !isNaN(kg) : false)
      } else if (maxWeight === false) {
        editedItems = filter(editedItems, obj => obj.traction ? parseInt(obj.traction) <= kg && !isNaN(kg) : false)
      }

      return editedItems
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      return this.getOptions().then(() => this.getVehicle()).catch(r => {
        this.$root.$emit('activeLoader', false)
        return r
      })
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    getOptions () {
      const axiosArray = []
      this.getFields()
      this.getWeightOptions()
      this.getUseCaseOptions()
      this.getRemovedOptions()
      this.getHasTrackerOptions()
      this.getOwnershipTypeOptions()
      axiosArray.push(this.getTrackers())
      axiosArray.push(this.getEnum('owner', 'ownerOptions'))
      axiosArray.push(this.getEnum('fuel_type', 'fuelsOptions'))
      axiosArray.push(this.getEnum('company', 'companyOptions'))
      axiosArray.push(this.getEnum('equipment', 'equipmentOptions'))
      axiosArray.push(this.getEnum('vehicle_state', 'vehicleStateOptions'))
      axiosArray.push(this.getEnum('activity_sector', 'activitySectorOptions'))
      axiosArray.push(this.getEnum('classification', 'classificationOptions'))
      axiosArray.push(this.getEnum('registry_code', 'wasteOptions'))
      return Vue.myAll(axiosArray).then(r => r)
    },
    getVehicle () {
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        const editedItems = []
        const activitySectorOptions = this.activitySectorOptions
        const ownerOptions = this.ownerOptions
        const ownershipTypeOptions = this.ownershipTypeOptions
        const vehicleStateOptions = this.vehicleStateOptions
        const companyOptions = this.companyOptions
        const classificationOptions = this.classificationOptions
        const fuelsOptions = this.fuelsOptions
        const equipmentOptions = this.equipmentOptions
        const trackers = this.trackers
        const useCase = this.useCase
        const options = {
          activitySectorOptions,
          ownerOptions,
          ownershipTypeOptions,
          vehicleStateOptions,
          companyOptions,
          classificationOptions,
          fuelsOptions,
          equipmentOptions,
          trackers,
          useCase
        }
        vehicles.forEach(vehicle => {
          const editedVehicle = this.assembleVehicle(vehicle, options)
          editedItems.push(editedVehicle)
        })
        this.originalItems = []
        this.items = []
        if (!vehicles.isError) {
          this.originalItems = orderBy(editedItems, 'plateNumber')
          this.items = cloneDeep(this.originalItems)
        } else {
          this.$root.$emit('showErrorMessage', { message: vehicles.message, mustBeExpelled: false })
        }
        this.$root.$emit('activeLoader', false)
        return this.items
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    assembleVehicle (vehicle, options) {
      let newVehicle = this.getMainVehicleData(vehicle, options)
      newVehicle = this.getExtraData(vehicle, newVehicle, options)
      newVehicle = this.getVehicleUsage(vehicle, newVehicle, options)
      newVehicle = this.getAlbo(vehicle, newVehicle)
      newVehicle = this.getExtraEquipment(vehicle, newVehicle)
      newVehicle = this.getOBU(vehicle, newVehicle, options)
      newVehicle = this.getParsedDates(vehicle, newVehicle)
      return newVehicle
    },
    getMainVehicleData (vehicle, options) {
      const classification = find(options.classificationOptions, obj => vehicle.type && vehicle.type.classification !== null && obj.value === vehicle.type.classification)
      const fuel = find(options.fuelsOptions, obj => vehicle.type && vehicle.type.fuelType !== null && obj.value === vehicle.type.fuelType)
      const equipment = find(options.equipmentOptions, obj => vehicle.type && vehicle.type.equipment !== null && obj.value === vehicle.type.equipment)

      return {
        id: vehicle.id,
        plateNumber: vehicle.plateNumber,
        typeBrand: (vehicle.type && vehicle.type.brand) || '',
        typeModel: (vehicle.type && vehicle.type.model) || '',
        registrationDate: vehicle.registrationDate,
        classification: classification && classification.text,
        classificationValue: classification && classification.value,
        chassisNumber: vehicle.chassisNumber,
        payload: vehicle.type && vehicle.type.payload,
        engineDisplacement: vehicle.type && vehicle.type.engineDisplacement,
        kw: vehicle.type && vehicle.type.kw,
        fuel: fuel && fuel.text,
        fuelValue: fuel && fuel.value,
        seats: vehicle.type && vehicle.type.seats,
        emissionStandard: vehicle.type && vehicle.type.emissionStandard,
        trailerHitch: vehicle.type && vehicle.type.trailerHitch ? this.$t('message.yes') : this.$t('message.no'),
        equipment: equipment && equipment.text,
        equipmentValue: equipment && equipment.value
      }
    },
    getExtraData (oldVehicle, vehicle, options) {
      const activitySector = find(options.activitySectorOptions, obj => obj.value === oldVehicle.activitySector && oldVehicle.activitySector !== null)
      const property = find(options.ownerOptions, obj => oldVehicle.ownership && obj.value === oldVehicle.ownership.owner && oldVehicle.ownership.owner !== null)
      const state = find(options.vehicleStateOptions, obj => obj.value === oldVehicle.state && oldVehicle.state !== null)
      const userCompany = find(options.companyOptions, obj => obj.value === oldVehicle.userCompany && oldVehicle.userCompany !== null)
      const ownUse = find(options.useCase, obj => obj.value === oldVehicle.ownUse)
      const measures = oldVehicle.measures && oldVehicle.measures.length && oldVehicle.measures.length !== 0 ? last(oldVehicle.measures) : {}

      vehicle.disabledText = oldVehicle.disablingDate ? this.$t('message.no') : this.$t('message.yes')
      vehicle.disabledDate = oldVehicle.disablingDate ? oldVehicle.disablingDate : this.$t('message.noDate')
      vehicle.disabledValue = !!oldVehicle.disablingDate
      vehicle.stateText = state && state.text
      vehicle.stateValue = state && state.value
      vehicle.property = property && property.text
      vehicle.propertyValue = property && property.value
      vehicle.userCompanyText = userCompany && userCompany.text
      vehicle.userCompanyValue = userCompany && userCompany.value
      vehicle.activitySectorText = activitySector && activitySector.text
      vehicle.activitySectorValue = activitySector && activitySector.value
      vehicle.kmCost = oldVehicle.kmCost
      vehicle.avgConsumption = oldVehicle.avgConsumption
      vehicle.lengthCm = oldVehicle.type && oldVehicle.type.length
      vehicle.widthCm = oldVehicle.type && oldVehicle.type.width
      vehicle.traction = oldVehicle.type && oldVehicle.type.traction // was changed in max weight
      vehicle.lastKm = measures && measures.km
      vehicle.lastDate = measures && measures.date
      vehicle.automathicKm = oldVehicle.estimatedKm
      vehicle.automathicDate = `${DateTime.local().plus({ days: -1 }).toSQLDate()} 00:00:00`
      vehicle.description = oldVehicle.description
      vehicle.ownUse = ownUse && ownUse.text
      return cloneDeep(vehicle)
    },
    getVehicleUsage (oldVehicle, vehicle, options) {
      const ownershipObj = this.getOwnershipType(cloneDeep(oldVehicle.ownership), options)
      const rental = oldVehicle.ownership && oldVehicle.ownership.rental
      const leasing = oldVehicle.ownership && oldVehicle.ownership.leasing
      const purchase = oldVehicle.ownership && oldVehicle.ownership.purchase
      vehicle.ownership = ownershipObj && ownershipObj.name
      vehicle.ownershipValue = ownershipObj && ownershipObj.ownershipValue
      vehicle.rentalStart = rental && rental.startDate && rental.type !== 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.rentalEnd = rental && rental.endDate && rental.type !== 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.loanStart = rental && rental.startDate && rental.type === 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.loanEnd = rental && rental.endDate && rental.type === 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.leasingStart = leasing && leasing.startDate ? leasing.startDate : this.$t('message.noDate')
      vehicle.leasingEnd = leasing && leasing.endDate ? leasing.endDate : this.$t('message.noDate')
      vehicle.purchaseDate = purchase && purchase.date ? purchase.date : null
      vehicle.company = rental && rental.company
      vehicle.rentalPrice = rental && rental.price
      vehicle.rentalRedemptionPrice = rental && rental.redemptionPrice
      vehicle.relief = rental && rental.relief
      vehicle.kmYear = rental && rental.kmYear
      vehicle.maxKm = rental && rental.maxKm
      vehicle.loanerVehicle = rental && rental.type === 'loan' ? this.$t('message.yes') : this.$t('message.no')
      vehicle.towTruck = rental && rental.towTruck ? this.$t('message.yes') : this.$t('message.no')
      vehicle.leasingRedemptionPrice = leasing && leasing.redemptionPrice
      vehicle.purchasePrice = purchase && purchase.price
      vehicle.purchaseKm = purchase && purchase.km
      return cloneDeep(vehicle)
    },
    getOwnershipType (ownership, options) {
      if (ownership) {
        let name = null
        const rentalType = ownership.rental && ownership.rental.type
        const rentalStart = ownership.rental && ownership.rental.startDate && DateTime.fromSQL(ownership.rental.startDate)
        const leasingStart = ownership.leasing && ownership.leasing.startDate && DateTime.fromSQL(ownership.leasing.startDate)
        const rentalEnd = ownership.rental && ownership.rental.endDate && DateTime.fromSQL(ownership.rental.endDate)
        const leasingEnd = ownership.leasing && ownership.leasing.endDate && DateTime.fromSQL(ownership.leasing.endDate)
        const purchaseStart = ownership.purchase && ownership.purchase.date && DateTime.fromSQL(ownership.purchase.date)
        let ownershipValue = null
        if (purchaseStart) name = this.$tc('message.property', 1)
        if (!name && rentalEnd > leasingEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (!name && leasingEnd > rentalEnd) name = 'Leasing'
        if (!name && leasingEnd) name = 'Leasing'
        if (!name && rentalEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (name) {
          ownershipValue = find(options.ownershipTypeOptions, obj => obj.text === name).value
        }
        return {
          ownershipValue,
          name,
          rentalStart,
          rentalEnd,
          leasingStart,
          leasingEnd,
          purchaseDate: purchaseStart
        }
      }
      return null
    },
    getAlbo (oldVehicle, vehicle) {
      const registry = oldVehicle.registry
      const wasteOptions = this.wasteOptions
      vehicle.registryRegistrationDate = registry && registry.registrationDate
      vehicle.behalfOf = registry && registry.behalfOf
      vehicle.hasAlboCodes = registry && registry.codes && registry.codes.length !== 0 ? this.$t('message.yes') : this.$t('message.no')
      let editedCodes = ''
      if (registry && registry.codes && registry.codes.length !== 0 && wasteOptions && wasteOptions.length !== 0) {
        registry.codes.forEach((code, index) => {
          const foundedCode = find(wasteOptions, obj => obj.value === code)
          if (foundedCode) editedCodes += `${index !== 0 ? ', ' : ''}${foundedCode.text}`
        })
      }
      vehicle.allALBOCodes = editedCodes
      return cloneDeep(vehicle)
    },
    getExtraEquipment (oldVehicle, vehicle) {
      const extraEquipment = oldVehicle.extraEquipment
      vehicle.snowChains = extraEquipment && extraEquipment.snowChains ? this.$t('message.yes') : this.$t('message.no')
      vehicle.cid = extraEquipment && extraEquipment.cid ? this.$t('message.yes') : this.$t('message.no')
      vehicle.airConditioning = extraEquipment && extraEquipment.airConditioning ? this.$t('message.yes') : this.$t('message.no')
      vehicle.gilet = extraEquipment && extraEquipment.gilet ? this.$t('message.yes') : this.$t('message.no')
      vehicle.extraEquipmentKeys = extraEquipment && extraEquipment.key
      vehicle.tireType = extraEquipment && extraEquipment.tireType
      return cloneDeep(vehicle)
    },
    getOBU (oldVehicle, vehicle, options) {
      const tracker = oldVehicle.imei ? find(options.trackers, obj => obj.imei === oldVehicle.imei) : null
      vehicle.trackerSerialNumber = (tracker && tracker.serialNumber) || null
      vehicle.trackerPurchaseDate = (tracker && tracker.purchaseDate) || null
      return cloneDeep(vehicle)
    },
    getParsedDates (oldVehicle, vehicle) {
      vehicle.parsedRegistrationDate = vehicle.registrationDate ? DateTime.fromSQL(vehicle.registrationDate).toFormat('dd-MM-y') : this.$t('message.noDate')
      vehicle.parsedDisabledDate = oldVehicle.disablingDate ? DateTime.fromFormat(oldVehicle.disablingDate, 'yyyy-MM-dd').toFormat('dd-MM-y') : this.$t('message.noDate')
      vehicle.parsedLastDate = vehicle.lastDate ? DateTime.fromFormat(vehicle.lastDate, 'yyyy-MM-dd').toFormat('dd-MM-y') : this.$t('message.noDate')
      vehicle.parsedAutomathicDate = vehicle.automathicDate ? DateTime.fromSQL(vehicle.automathicDate).toFormat('dd-MM-y') : this.$t('message.noDate')
      vehicle.parsedPurchaseDate = vehicle.purchaseDate ? DateTime.fromFormat(vehicle.purchaseDate, 'yyyy-MM-dd').toFormat('dd-MM-y') : this.$t('message.noDate')
      vehicle.parsedRegistryRegistrationDate = vehicle.registryRegistrationDate ? DateTime.fromSQL(vehicle.registryRegistrationDate).toFormat('dd-MM-y') : this.$t('message.noDate')
      vehicle.parsedTrackerPurchaseDate = vehicle.trackerPurchaseDate ? DateTime.fromSQL(vehicle.trackerPurchaseDate).toFormat('dd-MM-y') : this.$t('message.noDate')
      return cloneDeep(vehicle)
    },
    getFields () {
      this.fields = [
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1), sortable: true, sortDirection: 'desc' },
        { key: 'typeBrand', label: this.$t('message.brand'), sortable: true, sortDirection: 'desc' },
        { key: 'typeModel', label: this.$tc('message.model', 1), sortable: true, sortDirection: 'desc' },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'userCompanyText', label: this.$tc('message.society', 1), sortable: true, sortDirection: 'desc' },
        { key: 'property', label: this.$tc('message.property', 1), sortable: true, sortDirection: 'desc' },
        { key: 'trackerSerialNumber', label: `${this.$t('message.serialNumber')} OBU`, sortable: true, sortDirection: 'desc' },
        { key: 'ownership', label: this.$t('message.vehicleUsage'), sortable: true, sortDirection: 'desc' },
        { key: 'disabledText', label: `${this.$t('message.inOperation')}`, sortable: true, sortDirection: 'desc' },
        { key: 'stateText', label: this.$tc('message.status', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    getUseCaseOptions () {
      this.useCase = [
        { value: true, text: this.$t('message.own') },
        { value: false, text: this.$t('message.thirdParties') }
      ]
    },
    getExcelFields () {
      return [
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1) },
        { key: 'typeBrand', label: this.$t('message.brand') },
        { key: 'typeModel', label: this.$tc('message.model', 1) },
        { key: 'parsedRegistrationDate', label: `${this.$tc('message.date', 1)} ${this.$tc('message.matriculation', 1).toLowerCase()}` },
        { key: 'classification', label: this.$tc('message.type', 1) },
        { key: 'chassisNumber', label: this.$t('message.chassisNumber') },
        { key: 'payload', label: this.$t('message.payload') },
        { key: 'engineDisplacement', label: this.$t('message.engineDisplacement') },
        { key: 'kw', label: `${this.$t('message.power')} (kW)` },
        { key: 'fuel', label: `${this.$tc('message.type', 1)} ${this.$tc('message.refueling', 1).toLowerCase()}` },
        { key: 'seats', label: this.$t('message.seats') },
        { key: 'emissionStandard', label: this.$t('message.emissionStandard') },
        { key: 'trailerHitch', label: this.$t('message.trailerHitch') },
        { key: 'equipment', label: `${this.$tc('message.type', 1)} ${this.$t('message.vehicleSetUp').toLowerCase()}` },
        { key: 'disabledText', label: `${this.$tc('message.vehicle', 1)} ${this.$tc('message.inOperation', 1).toLowerCase()}` },
        { key: 'parsedDisabledDate', label: `${this.$t('message.date')} ${this.$tc('message.disabled', 2).toLowerCase()}` },
        { key: 'stateText', label: `${this.$tc('message.status', 1)} ${this.$tc('message.vehicle', 1).toLowerCase()}` },
        { key: 'property', label: this.$tc('message.property', 1) },
        { key: 'ownUse', label: this.$tc('message.behalfOf', 1), sortable: true, sortDirection: 'desc' },
        { key: 'userCompanyText', label: this.$t('message.userCompany') },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}` },
        { key: 'kmCost', label: this.$t('message.costPerKm') },
        { key: 'avgConsumption', label: this.$t('message.avgConsumption') },
        { key: 'lengthCm', label: this.$t('message.length') },
        { key: 'widthCm', label: this.$t('message.width') },
        { key: 'traction', label: `${this.$t('message.maxWeight')}` },
        { key: 'lastKm', label: `km (${this.$t('message.nowCheckedOnVehicle')})` },
        { key: 'parsedLastDate', label: `${this.$tc('message.date', 1)} ${this.$t('message.survey').toLowerCase()} km ${this.$t('message.manual').toLowerCase()}` },
        { key: 'automathicKm', label: `km (${this.$t('message.automaticCheck').toLowerCase()})` },
        { key: 'parsedAutomathicDate', label: `${this.$tc('message.date', 1)} ${this.$tc('message.update', 1).toLowerCase()} km ${this.$tc('message.automatic', 1).toLowerCase()}` },
        { key: 'description', label: this.$t('message.description') },
        { key: 'ownership', label: this.$t('message.vehicleUsage') },
        { key: 'company', label: this.$tc('message.society', 1) },
        { key: 'rentalStart', label: `${this.$t('message.date')} ${this.$t('message.start').toLowerCase()} ${this.$tc('message.rental', 1).toLowerCase()}` },
        { key: 'rentalEnd', label: `${this.$t('message.date')} ${this.$t('message.end').toLowerCase()} ${this.$tc('message.rental', 1).toLowerCase()}` },
        { key: 'rentalPrice', label: `${this.$tc('message.price', 1)} ${this.$tc('message.rental', 1).toLowerCase()}` },
        { key: 'rentalRedemptionPrice', label: `${this.$t('message.redemptionPrice')} ${this.$tc('message.rental', 1).toLowerCase()}` },
        { key: 'relief', label: `${this.$t('message.relief')} ${this.$tc('message.rental', 1).toLowerCase()}` },
        { key: 'kmYear', label: `km / ${this.$tc('message.year')}` },
        { key: 'maxKm', label: `km ${this.$tc('message.max', 2).toLowerCase()}` },
        { key: 'loanerVehicle', label: this.$t('message.loanerVehicle') },
        { key: 'towTruck', label: this.$t('message.towTruck') },
        { key: 'leasingStart', label: `${this.$t('message.date')} ${this.$t('message.start').toLowerCase()} leasing` },
        { key: 'leasingEnd', label: `${this.$t('message.date')} ${this.$t('message.end').toLowerCase()} leasing` },
        { key: 'loanEnd', label: `${this.$t('message.date')} ${this.$t('message.start').toLowerCase()} ${this.$t('message.loan').toLowerCase()}` },
        { key: 'loanStart', label: `${this.$t('message.date')} ${this.$t('message.end').toLowerCase()} ${this.$t('message.loan').toLowerCase()}` },
        { key: 'leasingRedemptionPrice', label: `${this.$t('message.redemptionPrice')} leasing` },
        { key: 'parsedPurchaseDate', label: `${this.$t('message.date')} ${this.$t('message.purchase').toLowerCase()}` },
        { key: 'purchasePrice', label: `${this.$tc('message.price', 1)} ${this.$t('message.purchase').toLowerCase()}` },
        { key: 'purchaseKm', label: `km ${this.$t('message.purchase').toLowerCase()}` },
        { key: 'parsedRegistryRegistrationDate', label: `${this.$t('message.date')} ${this.$t('message.registration').toLowerCase()} ${this.$tc('message.albo', 1).toLowerCase()}` },
        { key: 'behalfOf', label: this.$t('message.behalfOf') },
        { key: 'allALBOCodes', label: `${this.$tc('message.code', 2)} ${this.$t('message.albo2')}` },
        { key: 'snowChains', label: this.$tc('message.chain', 2) },
        { key: 'cid', label: this.$t('message.cid') },
        { key: 'airConditioning', label: this.$t('message.airConditioning') },
        { key: 'gilet', label: 'Gilet' },
        { key: 'extraEquipmentKeys', label: this.$tc('message.keyNumber') },
        { key: 'tireType', label: this.$t('message.seasonalTires') },
        { key: 'trackerSerialNumber', label: this.$t('message.serialNumber') },
        { key: 'parsedTrackerPurchaseDate', label: `${this.$tc('message.date', 1)} ${this.$t('message.purchase').toLowerCase()} OBU` }
      ]
    },
    getRemovedOptions () {
      this.removedOptions = [
        { value: '', text: this.$t('message.all') },
        { value: false, text: this.$t('message.yes') },
        { value: true, text: this.$t('message.no') }
      ]
    },
    getHasTrackerOptions () {
      this.hasTrackerOptions = [
        { value: '', text: this.$t('message.all') },
        { value: true, text: this.$t('message.yes') },
        { value: false, text: this.$t('message.no') }
      ]
    },
    getOwnershipTypeOptions () {
      this.ownershipTypeOptions = [
        { value: '', text: this.$t('message.selectOption') },
        { value: 'rental', text: this.$tc('message.rental', 1) },
        { value: 'leasing', text: 'Leasing' },
        { value: 'property', text: this.$tc('message.property', 1) },
        { value: 'loan', text: this.$tc('message.loan', 1) }
      ]
    },
    getWeightOptions () {
      this.maxWeightOption = [
        { value: true, text: this.$tc('message.equalOrMore', 1) },
        { value: false, text: this.$tc('message.equalOrLess', 1) }
      ]
    },
    getTrackers () {
      return Vue.myGet(this, '/trackers', 'trackers').then((items) => {
        this.trackers = items
        return true
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getEnum (path, obj) {
      const options = []

      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    resetFilters () {
      this.activitySectorFilter = ''
      this.companyFilter = ''
      this.ownerFilter = ''
      this.vehicleStateFilter = ''
      this.ownershipTypeFilter = ''
      this.removedFilter = ''
      this.hasTrackerFilter = ''
      this.$refs.vehicleTable.resetSearch()
    },
    handleExcel (fileName, fields) {
      return this.$refs.vehicleTable.excel(fileName, fields)
    }
  }
}
</script>
